import * as React from "react"

import { cn } from "@/lib/utils"

// Wellversed-branded card primitives.
//   Surface: white (#FFFFFF)
//   Border: slate-200 (#E2E8F0)
//   Shadow: 0 1px 3px rgba(0,0,0,0.05) (subtle)
//   Radius: 10px (within the 8–12px brand range)
//   Padding: 20px (within 16–24px)
//   Title:  Inter 17px / 600 / #0F0F0F
//   Desc:   Inter 14px / #64748B
const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "rounded-[10px] border border-[#E2E8F0] bg-white text-[#334155] shadow-[0_1px_3px_rgba(0,0,0,0.05)]",
      className
    )}
    {...props}
  />
))
Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 p-5", className)}
    {...props}
  />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "text-[17px] font-semibold leading-snug tracking-tight text-[#0F0F0F]",
      className
    )}
    {...props}
  />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-[14px] leading-relaxed text-[#64748B]", className)}
    {...props}
  />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-5 pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-5 pt-0", className)}
    {...props}
  />
))
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
